import BAudioPlaylist from "./BAudioPlaylist";
import cardSkin from "./skins/playlistCard/playlistCard";
// import H5AP_Plalist from "./player/playlist";
import bluePlaylistSkin from "./skins/bluePlaylist/bluePlaylist";
import "./../css/player.scss";

import "./skins/simpleSkin/style.scss";

// const H5AP_Plalist_Obj = new H5AP_Plalist();

document.addEventListener("DOMContentLoaded", function () {
  // initialize cardPlaylist
  const cardPlaylists = document.querySelectorAll(".audioPlaylistCard");
  cardPlaylists.forEach((playlist) => {
    let items = [];
    try {
      items = JSON.parse(playlist.dataset?.items);
      playlist.removeAttribute("data-items");
    } catch (error) {
      items = [];
    }
    cardPlaylist(playlist, {}, items);
  });

  // initialize bluePlaylists
  const bluePlaylists = document.querySelectorAll(".bluePlaylist:not(.elementorBluePlaylist)");

  bluePlaylists.forEach((playlist) => {
    let items = [];
    try {
      items = JSON.parse(playlist.dataset?.items);
      playlist.removeAttribute("data-items");
    } catch (error) {
      items = [];
    }
    bluePlaylist(playlist, {}, items);
  });

  // initialize simple playlist
  const simplePlaylists = document.querySelectorAll(".simplePlaylist:not(.elementorSimplePlaylist)");
  simplePlaylists.forEach((playlist) => {
    let items = [];
    let options = {};
    try {
      items = JSON.parse(playlist.dataset?.items);
      options = JSON.parse(playlist.dataset?.options);
      playlist.removeAttribute("data-items");
      playlist.removeAttribute("data-options");
    } catch (error) {
      items = [];
    }

    simplePlaylist(playlist, options, items);
  });

  // Elementor
  window.addEventListener("elementor/frontend/init", function () {
    //This is for Playlist
    elementorFrontend.hooks.addAction("frontend/element_ready/PlaylistAudioPlayer.default", function (scope, $) {
      const hExtensive = $(scope).find(".elementorBluePlaylist")?.[0];
      if (hExtensive) {
        let items = [];
        try {
          items = JSON.parse(hExtensive.dataset?.items);
          hExtensive.removeAttribute("data-items");
        } catch (error) {
          items = [];
        }
        bluePlaylist(hExtensive, {}, items);
      }

      const elementorSimplePlaylist = $(scope).find(".elementorSimplePlaylist")?.[0];

      if (elementorSimplePlaylist) {
        let items = [];
        try {
          items = JSON.parse(elementorSimplePlaylist.dataset?.items);
          elementorSimplePlaylist.removeAttribute("data-items");
        } catch (error) {
          items = [];
        }
        simplePlaylist(elementorSimplePlaylist, {}, items);
      }
    });
  });
});

export const bluePlaylist = (dom, options = {}, items = []) => {
  const player = new BAudioPlaylist(
    dom,
    {
      controls: bluePlaylistSkin(items),
      ...options,
    },
    items
  );
  return player;
};

export const cardPlaylist = (dom, options = {}, items = []) => {
  const player = new BAudioPlaylist(
    dom,
    {
      controls: cardSkin(items),
      ...options,
    },
    items
  );

  // the code will be extract to another function
  dom.getElementsByClassName("down-header")[0]?.addEventListener("click", function () {
    var list = dom.querySelector("#list");
    list.style.height = parseInt(dom.querySelector(".flat-black-player-container").offsetHeight) - 135 + "px";
    dom.querySelector("#list-screen").classList.remove("slide-out-top");
    dom.querySelector("#list-screen").classList.add("slide-in-top");
    dom.querySelector("#list-screen").style.display = "block";
  });

  dom.getElementsByClassName("hide-playlist")[0]?.addEventListener("click", function () {
    dom.querySelector("#list-screen").classList.remove("slide-in-top");
    dom.querySelector("#list-screen").classList.add("slide-out-top");
    dom.querySelector("#list-screen").style.display = "none";
  });

  return player;
};

export const simplePlaylist = (dom, options = {}, items = []) => {
  const player = new BAudioPlaylist(
    dom,
    {
      ...options,
    },
    items
  );
  return player;
};
